"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var EmptyState = function EmptyState(_ref) {
  var content = _ref.content,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    alignItems: "center",
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconType: "FontAwesome",
    iconName: iconName,
    iconSize: iconSize,
    iconColor: "#bdbdbd"
  }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    color: "textSecondary",
    variant: "h6",
    gutterBottom: true
  }, title), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    component: "div"
  }, content)));
};

EmptyState.propTypes = {
  title: _propTypes["default"].string.isRequired,
  iconName: _propTypes["default"].string,
  content: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node, _propTypes["default"].string])
};
EmptyState.defaultProps = {
  title: "",
  iconName: "",
  content: "",
  iconSize: 100
};
var _default = EmptyState;
exports["default"] = _default;